import { EqxLink } from '@equinoxx/react'
import React from 'react'
import { useMainLayoutContext } from '../../../components/MainLayout'
import EqxContinuumNav, { EqxContinuumNavPageActionItem } from './EqxContinuumNav'
import EqxContinuumSidebar, { EqxContinuumSidebarItem, EqxContinuumSidebarSubItem } from './EqxContinuumSidebar'

const EqxContinuumHeaderTopRightMenu = (props: { children: React.ReactNode }) => {
    return <ul className="header-right-dropdown-menu">{props.children}</ul>
}
const EqxContinuumHeaderTopRightMenuItem = (props: {
    icon: string
    text: string
    url?: string
    onClick?: React.MouseEventHandler<HTMLAnchorElement>
    newWindow?: boolean
}) => {
    const icon = props.icon
    const text = props.text
    const url = props.url
    const context = useMainLayoutContext()

    const onClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        if (props.onClick) props.onClick(e)
        context.events.trigger('clickItem')
    }
    const newWindow = props.newWindow
    const target = newWindow ?? false ? '_blank' : ''

    return (
        <li>
            <EqxLink to={url ?? '#'} onClick={onClick ?? (() => { })} target={target}>
                {icon && <span className={icon}></span>} {text}{' '}
                {newWindow && <span className="fas fa-arrow-up-right-from-square"></span>}
            </EqxLink>
        </li>
    )
}
interface EqxContinuumHeaderTopRightButtonProps {
    icon: string
    name: string
    title?: string
    children?: React.ReactNode
    notifications?: number
}
const EqxContinuumHeaderTopRightButton = (props: EqxContinuumHeaderTopRightButtonProps) => {
    const name = props.name
    const icon = props.icon
    const menu = props.children

    const context = useMainLayoutContext()
    let [showMenu, setShowMenu] = React.useState(false)

    const toggleMenu = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        if (!showMenu) context.events.trigger('showMenu', [name])
        setShowMenu(!showMenu)
    }

    React.useEffect(() => {
        const event = context.events.on('showMenu', (menuName: string) => {
            if (menuName !== name) setShowMenu(false)
        })
        const event2 = context.events.on('clickItem', () => {
            setShowMenu(false)
        })
        return () => {
            context.events.removeEvent('showMenu', event)
            context.events.removeEvent('showMenu', event2)
        }
    })

    return (
        <li>
            <a href="#" onClick={toggleMenu}>
                <span className={'page-action-icon ' + icon}></span>
                {!!props.notifications && (
                    <span className="badge bg-danger rounded-pill position-absolute top-0 end-0 m-1">
                        {props.notifications}
                    </span>
                )}
            </a>
            {menu && (
                <div
                    id={'header-right-' + name + '-dropdown'}
                    className={'header-right-dropdown' + (showMenu ? '' : ' collapse')}
                >
                    {menu}
                </div>
            )}
        </li>
    )
}

interface EqxContinuumHeaderProps {
    pageTitle: string | React.ReactNode
    pageActions?: React.ReactNode
    navItems?: React.ReactNode
    topRightMenu?: React.ReactNode
    logo: React.ReactNode
    sidebar: React.ReactNode
}

const EqxContinuumHeader = (props: EqxContinuumHeaderProps) => {
    return (
        <>
            <header id="main">
                <div id="header-left">
                    <EqxLink id="header-left-link" to="/">
                        {props.logo}
                    </EqxLink>
                </div>
                <div id="header-right">
                    <ul id="header-right-icons">{props.topRightMenu}</ul>
                </div>
            </header>
            <EqxContinuumNav pageActions={props.pageActions} pageTitle={props.pageTitle}></EqxContinuumNav>
            <EqxContinuumSidebar>{props.sidebar}</EqxContinuumSidebar>
        </>
    )
}

export {
    EqxContinuumHeader as default,
    EqxContinuumHeaderTopRightButton,
    EqxContinuumHeaderTopRightMenu,
    EqxContinuumHeaderTopRightMenuItem,
    EqxContinuumNavPageActionItem,
    EqxContinuumSidebarItem,
    EqxContinuumSidebarSubItem
}

